export default __webpack_public_path__ + "static/logo-6aa03baff9d2882a896a8519f5747038.webp";